import * as R from 'ramda'
import PropTypes from 'prop-types'
import { useAccessControl } from './useAccessControl'
import { AccessType } from 'app/auth/accessControlService'
import { isFunction } from 'lodash'

const AccessControl = ({
  accesses,
  context,
  children,
  deniedComponent = null,
}) => {
  const { isGranted, restrictionContext } = useAccessControl(accesses, context)
  if (isFunction(children)) {
    return children(isGranted, restrictionContext)
  }
  return isGranted ? children : deniedComponent
}

AccessControl.propTypes = {
  accesses: PropTypes.arrayOf(PropTypes.oneOf(R.values(AccessType))).isRequired,
  context: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  deniedComponent: PropTypes.element,
}

export default AccessControl
